<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer"/>
            <v-toolbar-title
            >{{
                    `${ $route.meta.title }` | t
                }}<span style="color:gray;">{{ ` (${ ruleCount })` }}</span></v-toolbar-title
            >
            <v-combobox
                    v-if="hasPermissionForAction(PermissionsConstants.RULES, PermissionsConstants.SEARCH)"
                    :items="searchHistory"
                    :value="searchRuleString"
                    @input="controlSearchString($event)"
                    item-text="keyword"
                    id="searchInput"
                    class="mt-6 mx-2"
                    :placeholder="t('Rule info provider, percent, entry type')"
                    prepend-inner-icon="search"
                    clearable
                    flat
                    solo
                    dense
            >
                <template slot="item" slot-scope="data">
                    <span
                            @click="updateRuleSearchOnClick(data.item.keyword)"
                            style="width: 100%; height: 100%"
                            class="pa-2"
                    >{{ data.item.keyword }}</span
                    >
                </template>
            </v-combobox>
            <v-spacer v-else/>
            <v-menu
                    offset-y
                    bottom
                    left
                    v-if="$route.name === 'rule-list' && user && user.role === PermissionsConstants.ROLE_SUPERADMIN"
            >
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleApplyRules">
                        <v-list-item-title>{{ "Apply rules" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn
                    dark
                    color="bal-red"
                    class="px-2 ml-2"
                    style="min-width: 0;"
                    v-if="hasPermissionForAction(PermissionsConstants.RULES, PermissionsConstants.CREATE)"
                    @click.stop="openNewRuleDrawer"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen"/>

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <rule-view v-if="$route.name === 'rule-view'"></rule-view>
            <rule-edit v-if="$route.name === 'rule-edit'"></rule-edit>
        </v-navigation-drawer>

        <!-- Main content -->
        <v-main>
            <router-view/>
        </v-main>

        <!-- Footer -->
        <page-footer/>

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ errorMessage }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import RuleView from "../pages/rules/rule-view.vue";
import RuleEdit from "../pages/rules/rule-edit.vue";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    components: {
        RuleView,
        RuleEdit,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async created() {
        await this.getSearchHistory(this.$route.path.replace("/", ""));
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
        if (this.export_clients.length === 0) {
            await this.getFrequentlyUsedQueries({ export_clients: true, clients: true, stores: true, tags: true });
        }
    },
    async destroyed() {
        if (this.searchRuleString.length > 0) await this.resetRuleSearch();
        document.removeEventListener("keydown", this.handleKeyboardListener);
        await this.setRequestSuccess(false);
        await this.setErrorMessage("");
    },
    methods: {
        ...mapMutations("RuleStore", [
            "resetActiveRule",
            "updateRuleSearch",
            "setRequestSuccess",
            "setErrorMessage",
            "resetRuleSearch"
        ]),
        ...mapActions("SearchHistoryStore", ["getSearchHistory"]),
        ...mapActions("RuleStore", ["getRuleData", "applyRulesToSales"]),
        ...mapActions(["getFrequentlyUsedQueries"]),
        openNewRuleDrawer() {
            return this.$router.push({ name: "rule-edit", params: { ruleId: "new" } });
        },
        async updateUserSearch(value) {
            await this.updateUserSearch({ term: value });
            await this.setRequestSuccess(false);
            await this.setErrorMessage("");
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        async handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                await this.resetActiveRule();
                return await this.$router.push({ name: "rule-list" });
            } else if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                await this.updateRuleSearch({
                    term: document.querySelector("#searchInput").value
                });
            }
            if (
                    this.activeRule &&
                    Object.keys(this.activeRule).length > 0 &&
                    this.activeRule.id !== "new" &&
                    this.$route.name !== "rule-edit"
            ) {
                let currentRuleIndex = this.rules[this.activeRule.info_provider].findIndex(
                        p => p.id === this.activeRule.id
                );
                if (e.key === "ArrowUp") {
                    if (currentRuleIndex !== 0) {
                        const newRuleId = this.rules[this.activeRule.info_provider][currentRuleIndex - 1].id;
                        await this.getRuleData(newRuleId);
                        return await this.$router.push({ name: this.$route.name, params: { ruleId: newRuleId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentRuleIndex + 1 !== this.rules[this.activeRule.info_provider].length) {
                        const newRuleId = this.rules[this.activeRule.info_provider][currentRuleIndex + 1].id;
                        await this.getRuleData(newRuleId);
                        return await this.$router.push({ name: this.$route.name, params: { ruleId: newRuleId } });
                    }
                }
            }
        },
        async updateRuleSearchOnClick(value) {
            await this.updateUserSearch({
                term: value
            });
        },
        controlSearchString(value) {
            if (value === "") this.updateUserSearch(value);
        },
        async handleApplyRules() {
            this.applyRulesToSales()
        }
    },
    computed: {

        ...mapState("RuleStore", [
            "drawerOpen",
            "searchRuleString",
            "requestSuccess",
            "rules",
            "activeRule",
            "ruleCount",
            "requestError",
            "errorMessage"
        ]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapState(["export_clients", "clients", "tags", "user"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
